module.exports = __webpack_public_path__ + "static/media/Bel.dbd398c6.mp3";